import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { format } from 'date-fns';
import {
  Container,
  ReferenceItem,
  ReferenceLabel,
  ReferencesList,
  ReferenceValue,
  TotalItem,
  TotalItemLabel,
  TotalItemValue,
  TotalsList,
} from './css';

const ShipmentInfo = ({ data }) => (
  <Container>
    <ReferencesList>
      {data.probillNumber
        ? (
          <ReferenceItem>
            <ReferenceLabel>{t('Pro Bill')}</ReferenceLabel>
            <ReferenceValue>{data.probillNumber}</ReferenceValue>
          </ReferenceItem>
        )
        : (
          <ReferenceItem>
            <ReferenceLabel>{t('Bill')}</ReferenceLabel>
            <ReferenceValue>{data.probillNumber || data.billNumber}</ReferenceValue>
          </ReferenceItem>
        )}

      <ReferenceItem>
        <ReferenceLabel>{t('PO')}</ReferenceLabel>
        <ReferenceValue>{data.poNumber}</ReferenceValue>
      </ReferenceItem>
      <ReferenceItem>
        <ReferenceLabel>{t('ShipperReference')}</ReferenceLabel>
        <ReferenceValue>{data.shipperReferenceNumber}</ReferenceValue>
      </ReferenceItem>
      {data.rlProbill && (
        <ReferenceItem>
          <ReferenceLabel>{t('RLProbill')}</ReferenceLabel>
          <ReferenceValue>{data.rlProbill}</ReferenceValue>
        </ReferenceItem>
      )}
      {data && data.deliveryAppointment && data.deliverByEnd && (
        <ReferenceItem>
          <ReferenceLabel>
            {t('AppointmentDetails')}
            :
          </ReferenceLabel>
          <ReferenceValue>
            {format(new Date(data.deliveryAppointment), 'MMM d, yyyy HH:mm')}
            {data.deliverByEnd
              && new Date(data.deliveryAppointment).getTime()
                !== new Date(data.deliverByEnd).getTime()
              && ` - ${format(new Date(data.deliverByEnd), 'HH:mm')}`}
          </ReferenceValue>
        </ReferenceItem>
      )}
    </ReferencesList>

    <TotalsList>
      <TotalItem>
        <TotalItemLabel>
          {t('Total')}
          :
        </TotalItemLabel>
        <TotalItemValue>
          {data.pallets}
          {' '}
          {data.pallets === 1 ? t('Pallet') : t('Pallets')}
          {' '}
          {data.pieces}
          {' '}
          {data.pieces === 1 ? t('Piece') : t('Pieces')}
        </TotalItemValue>
      </TotalItem>
      <TotalItem>
        <TotalItemLabel>
          {t('TotalWeight')}
          :
        </TotalItemLabel>
        <TotalItemValue>{data.totalWeight}</TotalItemValue>
      </TotalItem>
    </TotalsList>
  </Container>
);

ShipmentInfo.propTypes = {
  data: PropTypes.shape({
    billNumber: PropTypes.string,
    probillNumber: PropTypes.string,
    poNumber: PropTypes.string,
    shipperReferenceNumber: PropTypes.string,
    rlProbill: PropTypes.string,
    deliveryAppointment: PropTypes.string,
    deliverByEnd: PropTypes.string,
    pallets: PropTypes.number,
    pieces: PropTypes.number,
    totalWeight: PropTypes.string,
  }),
};

export default ShipmentInfo;
